import { useState } from 'react'
import { Trans } from 'react-i18next'
import styled from 'styled-components'

import { premiumFontCss } from '@root/entities/premium/ui'
import { useTranslation } from '@root/shared/localization'
import { PremiumDialog } from '@root/shared/ui/premium-dialog'

import { BuyPremium } from '../common/buy-premium'
import { BuyPremiumSafetyCheck } from '../common/buy-premium-safety-check'

import type { CurrencyModel } from '@root/entities/currency'
import type { PremiumMetaModel } from '@root/entities/premium'
import type { ClassNameProps } from '@root/shared/react'
import type { DialogControlProps } from '@root/shared/ui-kit'

type Step = 'safety-check' | 'buy-premium'

type BuyPremiumDialogProps = {
  currency: CurrencyModel
  premium: PremiumMetaModel | undefined
  shouldCheckSafety?: boolean
} & ClassNameProps &
  DialogControlProps

export const BuyPremiumDialog: React.FC<BuyPremiumDialogProps> = ({
  className,
  currency,
  premium,
  open,
  onOpenChange,
  shouldCheckSafety = true,
}) => {
  const { t } = useTranslation()
  const [step, setStep] = useState<Step>(
    shouldCheckSafety ? 'safety-check' : 'buy-premium',
  )

  const renderContent = () => {
    if (step === 'safety-check') {
      return (
        <BuyPremiumSafetyCheck
          currency={currency}
          onSuccess={() => setStep('buy-premium')}
        />
      )
    }

    return (
      <BuyPremium
        onClose={() => {
          onOpenChange?.(false)
        }}
        currency={currency}
        premium={premium}
        device="desktop"
      />
    )
  }

  return (
    <PremiumDialog
      open={open}
      onOpenChange={onOpenChange}
      title={
        <span>
          <Trans
            i18nKey={'premium.pay.subscription.title'}
            components={[<StyledTitle key={0} />]}
          />
        </span>
      }
      describedBy={t('premium.pay.subscription.title')}
      onClose={() => {
        onOpenChange?.(false)
      }}
      className={className}
    >
      {renderContent()}
    </PremiumDialog>
  )
}

const StyledTitle = styled.span`
  ${premiumFontCss}
`
